<app-modal
  [open]="open"
  (closed)="close(false)"
  class="calendar-delete-timeslot-modal"
>
  <div modal-header>
    <h2>{{'calendar.planning.delete-timeslot.title'|transloco }}</h2>
  </div>

  <div modal-body>
    <p>{{'calendar.planning.delete-timeslot.content'|transloco: {
      'day': getDayTranslationKey(),
      'start': timeslot?.start_utc | date:'shortTime',
      'end': timeslot?.end_utc | date:'shortTime'
    } }}</p>
  </div>

  <div modal-footer>
    <div class="calendar-delete-timeslot-modal__actions">
      <button class="button button--secondary"
              (click)="close(false)"
              [disabled]="submitting"
      >
        {{ 'calendar.planning.delete-timeslot.cancel'|transloco }}
      </button>
      <button class="button button--danger"
              [disabled]="submitting"
              (click)="submit()"
      >
        {{ 'calendar.planning.delete-timeslot.confirm'|transloco }}
      </button>
    </div>
  </div>
</app-modal>
